// store/ducks/profile.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Bit } from "types/types"; // change to your type if needed

interface ProfileState {
//   profileInfo: {
//     ownBit: boolean;
//     bitIndex: number;
//   } | null;
  bitData: Bit[] | null;
//   bitDetailInfo: {
//     hoveredBitId: number;
//     hoveredXCoordinate: number;
//     hoveredYCoordinate: number;
//     ownBit: boolean;
//   } | null;
}

const initialState: ProfileState = {
//   profileInfo: null,
  bitData: null,
//   bitDetailInfo: null,
};

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    // setProfileInfo(state, action: PayloadAction<ProfileState["profileInfo"]>) {
    //   state.profileInfo = action.payload;
    // },
    setBitData(state, action: PayloadAction<Bit[] | null>) {
      state.bitData = action.payload;
    },
    // setBitDetailInfo(state, action: PayloadAction<ProfileState["bitDetailInfo"]>) {
    //   state.bitDetailInfo = action.payload;
    // },
    clearProfileState(state) {
    //   state.profileInfo = null;
      state.bitData = null;
    //   state.bitDetailInfo = null;
    },
  },
});

// Export actions and reducer
export const {
//   setProfileInfo,
  setBitData,
//   setBitDetailInfo,
  clearProfileState,
} = profileSlice.actions;

export default profileSlice.reducer;
